import { Alert } from 'honeydew/Alert';
import { getBannerItemLinkUrl } from 'utils/bannerCarouselLinkUtils';

function getUnmatchedBannerLinkIssues(carousels) {
    const issues = [];

    carousels?.forEach((slice) => {
        slice.items?.forEach((item) => {
            const linkUrl = getBannerItemLinkUrl(item);

            if (linkUrl?.startsWith('#') && !item.linkedCarouselData) {
                issues.push({
                    id: item.id,
                    bannerName: item.name ?? item.bannerName ?? 'Unnamed banner',
                    slug: linkUrl.substring(1).trim(),
                });
            }
        });
    });

    return issues;
}

export function BannerLinkErrorAlert({ carousels }) {
    const issues = getUnmatchedBannerLinkIssues(carousels);

    if (!issues.length) {
        return null;
    }

    return (
        <Alert variant="error">
            <>
                <h3 className="mb-5 font-grotesk-bold">Banner Link Issue(s) Found!</h3>
                <ul className="list-disc pl-15">
                    {issues.map((issue) => (
                        <li key={`${issue.id}-${issue.slug}`}>
                            {issue.bannerName} is not properly linked to #{issue.slug}
                        </li>
                    ))}
                </ul>
            </>
        </Alert>
    );
}
